<template>
    <b-navbar-nav class="ml-auto">
        <b-nav-item v-if="!isLoggedIn" to="/login"><i class="fas fa-user"></i>&nbsp;Login</b-nav-item>
        <!-- <b-nav-item v-if="isLoggedIn" to="/logout">Logout</b-nav-item> -->
        <b-nav-item-dropdown v-if="isLoggedIn" :text="username" right>
            <template slot="button-content"><i class="fas fa-user"></i>&nbsp;{{username}}</template>
            <b-dropdown-item to="/changepassword">Change password</b-dropdown-item>
            <hr />
            <b-dropdown-item to="/logout">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
    </b-navbar-nav>
</template>

<script>

import { parseJwt } from '../util/parseJwt'

export default {
  name: 'userAuth',
  computed: {
    isLoggedIn () {
      if(this.$store.state.authentication.status) {
        return this.$store.state.authentication.status.loggedIn 
      } else {
        return false;
      }     
    },
    username () {
      if(this.$store.state.authentication.user.token) {
        return parseJwt(this.$store.state.authentication.user.token)['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name']
      } else {
        return '';
      }      
    }
  }
}
</script>
